// Frontend/src/components/admin/ui/EventTypeBadge.js

const eventTypeColors = {
  service: 'bg-blue-100 text-blue-800',
  conference: 'bg-purple-100 text-purple-800',
  outreach: 'bg-green-100 text-green-800',
  meeting: 'bg-yellow-100 text-yellow-800',
  training: 'bg-indigo-100 text-indigo-800',
  social: 'bg-pink-100 text-pink-800',
  default: 'bg-gray-100 text-gray-800'
};

const EventTypeBadge = ({ type }) => {
  const colorClass = eventTypeColors[type] || eventTypeColors.default;
  const displayText = type ? type.charAt(0).toUpperCase() + type.slice(1) : 'Unknown';

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClass}`}>
      {displayText}
    </span>
  );
};

export default EventTypeBadge;